import { render, staticRenderFns } from "./WxInterruptPage.vue?vue&type=template&id=7b3127d4&scoped=true&"
import script from "./WxInterruptPage.vue?vue&type=script&lang=js&"
export * from "./WxInterruptPage.vue?vue&type=script&lang=js&"
import style0 from "./WxInterruptPage.vue?vue&type=style&index=0&id=7b3127d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3127d4",
  null
  
)

export default component.exports